import React, { Component } from 'react'
import setTitle from "../../../helpers/TitleComponent";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { API_URL } from '../../../constants';
import { Messager } from 'rc-easyui';
import CreateTimesheetSystem from './CreateTimesheetSystem';
import { Panel } from 'rc-easyui';
import { Button } from 'reactstrap';
import { getUserId } from '../../../helpers/AuthHelper';
import { getFormattedDate, isEmpty } from "../../../helpers";
import { autoDissaperAction } from "../../../helpers/index";
import ViewTimesheetSystem from './ViewTimesheetSystem';


const axios = require("axios");

export default class TimesheetSystem extends Component {
    constructor(props) {
        super(props)
        this.childRef = React.createRef()
        this.state = {
            isLoading:false,
            timeSheet: [{
                fid: Math.random(),
                projectId: "",
                subprojectId: "",
                description: "",
                enabled: true,
                userId: "",
                timeSpent: "",
                btn1: "draft",
                btn2: false,
                status: "",
                comments: "",
                dateBs: "",
                operation: 'Add',
            }],
            rules: {
                projectId: ['required'],
                subprojectId: ['required'],
                description: ['required'],
                userId: ['required'],
                timeSpent: ['required'],
                status: ['required'],
                dateBs: ['required']
            },
            projectList: [],
            subprojectList: [],
            operation: "Add",
            editingRow: null,
            model: {},
            title: '',
            closed: true,
            selected: {},
            permissions: [],
            myForm: [],
            ID:[{fid:"",id:""}],
            user:[],
            username:"",
            userId:""
            
        }
    }



    formClear = () => {
        let clearTimesheet = {
            projectId: "",
            subprojectId: "",
            description: "",
            enabled: true,
            userId: "",
            timeSpent: "",
            status: "",
            comments: "",
            dateBs: ""
        };
        this.setState({
            timeSheet: clearTimesheet,
            operation: "Add",
        },
            function () {
                this.childRef.current.validate((errors) => { });
            }
        );
    }

    componentDidMount = () => {
        var data = getCookie('permission');
        var username = getCookie('username');
        this.setState({username:username})

        this.setState({
            permissions: JSON.parse(data),
        },
            () =>{
                setTitle('Timesheet System')
                this.getProjectId()
                this.getSubProjectId()
               
            }
        )
    }


    setUserId=(users)=>{
        var username=this.state.username
        users.map(user=>{
            if(user.username===username){
                this.setState({
                    userId:user.id
                })
            }
        })
    }


    clearSelected = () => {
        this.setState({
            selected: {}
        })
    }

    addForm = () => {
        let userId = this.state.userId
        this.setState({
            timeSheet: [...this.state.timeSheet, {
                ...{
                    projectId: "",
                    subprojectId: "",
                    description: "",
                    enabled: true,
                    userId: userId,
                    timeSpent: "",
                    status: "",
                    comments: "",
                    dateBs: "",
                    btn1: "draft",
                    btn2: false,
                    operation: "Add"
                }, fid: Math.random()
            }]
        })
    }



    getProjectId = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        //   console.log(erp_access_token)
        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
            })
            // let url = API_URL + 'api/fetchallprojectInfo';
            let url = `${API_URL}api/getactivecomboforprojectinfo?enabled=1`
            await axios.get(url, headerConfig)
                .then((response) => {

                    if (response.status === 200) {
                        var dataObject = response.data.object

                        this.setState({
                            projectList: dataObject
                        })

                    } else {
                        this.setState({
                            projectList: [],
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        projectList: [],
                    })
                    // alert ("Internal server error");
                    let response = error['response']
                    if (response !== undefined) {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            reload: false,
                            msg: response.data.message
                        })//Backend Validation Error i.e. 403
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false,
                        })// Caused due to syntax error in front end
                    }
                })


        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getProjectId()
            }
        }

    }

    getSubProjectId = async () => {
        let erp_access_token = getCookie('access_token')
        let erp_token_type = getCookie('token_type')
        let headerConfig = {
            headers: {
                authorization: erp_token_type + ' ' + erp_access_token,
                'Content-Type': 'application/json',
            },
        }
        //   console.log(erp_access_token)
        if (erp_access_token != null) {
            this.setState({
                isLoading: true,
            })
            // let url = API_URL + 'api/fetchallprojectInfo';
            let url = `${API_URL}api/getactivecomboforsubprojectinfo?enabled=1`

            await axios.get(url, headerConfig)
                .then((response) => {

                    if (response.status === 200) {
                        var dataObject = response.data.object

                        this.setState({
                            subprojectList: dataObject
                        })

                    } else {
                        this.setState({
                            subprojectList: [],
                        })
                    }
                })
                .catch((error) => {
                    this.setState({
                        subprojectList: [],
                    })
                    // alert ("Internal server error");
                    let response = error['response']
                    if (response !== undefined) {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            reload: false,
                            msg: response.data.message
                        })//Backend Validation Error i.e. 403
                    } else {
                        this.messager.alert({
                            title: 'Error',
                            icon: 'error',
                            msg: 'Internal Server Error',
                            reload: false,
                        })// Caused due to syntax error in front end
                    }
                })


        } else {
            const resp = await getAccessToken()
            if (resp) {
                this.getSubProjectId()
            }
        }

    }

    onSelectionChange = (selectedRow) => {
        if (selectedRow.status === "Draft" || selectedRow.status==="Rejected") {
            this.setState({
                selected: selectedRow,
            });
        } else {
            this.setState({
                selected: {}
            })
        }

    }

    buttonHandler = (id, data) => {
        let temp = [...this.state.timeSheet]
        temp = temp.map(form => {
            if (form.fid === id) {
                if (data === 'saved') {
                    form.btn2 = true

                }
                if (data === 'drafted') {
                    form.btn1 = data
                }
            }
            return form
        })
        this.setState({
            timeSheet: temp
        })
    }

    handleChange = (name, value, id) => {
        let temp = [...this.state.timeSheet]
        temp = temp.map(form => {
            if (form.fid === id) {
                console.log(name,value);
                form[name] = value
            }
            return form
        })
        this.setState({
            timeSheet: temp
        },()=>{console.log(this.state.timeSheet);})
    }

    validateTimeSpent=(timeSpent)=>{
        timeSpent=timeSpent+"H"
        return timeSpent
    }

    onEditClick = (row) => {
        let editableData = Object.assign({}, this.state.selected)
        this.state.projectList.map(projectlist => {
            if (editableData.projectId === projectlist.name) {
                editableData.projectId = projectlist.id
            }
        })
        this.state.subprojectList.map(subprojectlist => {
            if (editableData.subprojectId === subprojectlist.name) {
                editableData.subprojectId = subprojectlist.id
            }
        })
         
        
            this.setState({
                editingRow: row,
                model: Object.assign({}, row),
                title: 'Timesheet ',
                closed: false,
            });
       

        let tid = Math.random()
        this.setState({
            timeSheet: [...this.state.timeSheet, {
                ...{
                    projectId: editableData.projectId,
                    subprojectId: editableData.subprojectId,
                    description: editableData.description,
                    enabled: true,
                    userId: editableData.userId,
                    timeSpent: editableData.timeSpent,
                    status: editableData.status,
                    comments: " ",
                    dateBs: editableData.dateBs,
                    id: editableData.id,
                    btn1: "drafted",
                    operation: 'editClick',
                    btn2: false,
                }, fid: tid
            }]
        })
     

    }

    removeForm = (id) => {
        let temp = [...this.state.timeSheet]
        let index = null;
        let count=0
        temp.map(form => {
            count=count+1;
            if (form.fid === id) {
                index = temp.indexOf(form)
                console.log('index=' + index);
            }
        })
        
        if (index > -1) {
            temp.splice(index, 1)
        }
        this.setState({
            timeSheet: temp
        })


    }

    render() {
        const { permissions } = this.state
        return (
            <div>
                <Messager ref={ref => this.messager = ref}></Messager>

                <div className='container-fluid'>
                    {permissions.includes("timesheet-create") ? (
                        <div >
                            <CreateTimesheetSystem
                                timeSheet={this.state.timeSheet}
                                handleChange={this.handleChange}
                                projectList={this.state.projectList}
                                subprojectList={this.state.subprojectList}
                                operation={this.state.operation}
                                buttonHandler={this.buttonHandler}
                                rules={this.state.rules}
                                ref={this.childRef}
                                formClear={this.formClear}
                                clearSelected={this.clearSelected}
                                myForm={this.state.myForm}
                                addForm={this.addForm}
                                handleSave={this.handleSave}
                                permissions={this.state.permissions}
                                selected={this.state.selected}
                                onSelectionChange={this.onSelectionChange}
                                onEditClick={this.onEditClick}
                                removeForm={this.removeForm}
                                validateTimeSpent={this.validateTimeSpent}
                                userId={this.state.userId}
                                getUsers={this.getUsers}
                                setUserId={this.setUserId}
                            />
                        </div>
                    ) : null}

                </div>

            </div>
        )
    }
}
